import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeatureServicePlanItemClasses =
  | 'container'
  | 'planSelected'
  | 'titlePriceContainer'
  | 'priceValue'
  | 'priceGuideToggle'
  | 'expandIcon'
  | 'servicePlanCheckbox'
  | 'invertedIcon';

const featureServicePlanItemStyles = makeStyles<ISpcTheme, FeatureServicePlanItemClasses>(
  theme => ({
    container: {
      border: `1px solid ${theme.palette.primaryDisabled.main}`,
      padding: '20px 25px',
    },
    planSelected: {
      borderColor: theme.palette.primary.main,
    },
    titlePriceContainer: {
      paddingTop: '6px',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    servicePlanCheckbox: {
      position: 'relative',
      top: 4,
      left: -5,
      padding: 2,
    },
    priceValue: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: theme.typography.fontLG,
    },
    priceGuideToggle: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.secondary.main,
      fontSize: theme.typography.fontSM,
      textDecoration: 'underline',
    },
    expandIcon: {
      transition: theme.transitions.create(['transform']),
      fontSize: theme.typography.fontLG,
    },
    invertedIcon: {
      transform: 'rotate(180deg)',
    },
  }),
  { name: 'Customise_Feature_ServicePlanItem' },
);

export default featureServicePlanItemStyles;
